export const deepEquals = (objA, objB) => JSON.stringify(objA) === JSON.stringify(objB);
